<ng-template #submitSurveyConfirmation let-modal>
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title fw-bold">Form Submission Confirmation</h5>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body p-3">
      <p class="fw-bold warning-banner">
        <i class="fa fa-warning warning-icon" aria-hidden="true"></i>
        <span class='warning-text'>Submission cannot be cancelled or reversed.</span>
      </p>
      <p><strong class="text-caps text-primary">Your Declaration</strong></p>
      <div class="info-box">
        As of the time of submittal, the data provided herein accurately
        reflects submitter's knowledge of the organization's IT security.
      </div>
      <div class="d-flex align-items-center justify-content-left alert alert-warning">
        
        <div>
          <p class="text-bold"><i class="fa fa-exclamation-circle text-warning me-2" aria-hidden="true"></i>&nbsp;Responses shared with all relevant buyers</p>
          <small>Your form responses have been automatically
            shared with all buyers who require this form. This
            ensures your information is collected once and
            reused across the community.</small>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary acknowledge-button" (click)="modal.close('SUBMIT_SURVEY_OK')">
        Acknowledge
      </button>
    </div>
  </div>
</ng-template>